import React from "react";
import { Button, Space } from "antd";
import type { ColumnsType } from "antd/es/table";
import ImageWithSpinner from "../content/imagewithspinner";
import { MenuOption } from "../../types/types";
import dayjs, { Dayjs } from 'dayjs';

interface OptionTableColumnsProps {
    DragHandle: () => React.ReactElement;
    setopenEditMogmol: (open: boolean) => void;
    setSelectedOptionDisplayName: (value: string) => void;
    setSelectedMenuOptionGuid: (value: string) => void;
    setSelectedOptionDefaultSelection: (value: boolean) => void;
    setSelectedOptionGuid: (value: string) => void;
    handleDeleteOption: (id: string) => void;
    setSelectedOptionStartDate: (value: Dayjs | null) => void;
    setSelectedOptionEndDate: (value: Dayjs | null) => void;
    isReadOnly: boolean;
}

export const getOptionTableColumns = ({
    setopenEditMogmol,
    setSelectedOptionDisplayName,
    setSelectedMenuOptionGuid,
    setSelectedOptionDefaultSelection,
    setSelectedOptionGuid,
    handleDeleteOption,
    setSelectedOptionStartDate,
    setSelectedOptionEndDate,
    isReadOnly,
}: OptionTableColumnsProps): ColumnsType<MenuOption> => [
        {
            key: "sort",
            align: "center",
            width: 80,
            title: "",
            render: () => <span className="drag-handle">::</span>,
        },
        {
            key: "sortOrder",
            title: "Sort Order",
            dataIndex: "sortOrder",
            render: (value: number) => <span>{value}</span>,
        },
        {
            key: "imageName",
            title: "",
            dataIndex: "optionImageName",
            render: (value: string | undefined) => (
                <div style={{ marginRight: "10px", width: "50px", height: "50px" }}>
                    {value && <ImageWithSpinner imageUrl={value} />}
                </div>
            ),
        },
        {
            key: "displayText",
            title: "Kiosk Text",
            dataIndex: "displayName",
            render: (value: string, record: MenuOption) => 
                (<span style={{opacity: record.active ? 1 : 0.5}}>{value}</span> ),
        },
        {
            key: "option",
            title: "Option",
            dataIndex: "menuGuid",
            render: (_: string, record: MenuOption) => (<span style={{opacity: record.active ? 1 : 0.5}}>{record.menuOptionName}</span> ),
        },
        {
            key: "defaultSelection",
            title: "Default Selection",
            dataIndex: "defaultSelection",
            render: (value: boolean,record: MenuOption) => <span style={{opacity: record.active ? 1 : 0.5}}>{value ? "Yes" : "No"}</span>,
        },
        {
            key: "price",
            title: "Price",
            dataIndex: "price",
            render: (value: number | null | undefined, record: MenuOption) =>
                value != null ? <span style={{opacity: record.active ? 1 : 0.5}}>${value.toFixed(2)}</span> : <span>-</span>,
        },
        {
            key: "startDate",
            title: "Start Date",
            dataIndex: "startDate",
            render: (value: string, record: MenuOption) => <span style={{opacity: record.active ? 1 : 0.5}}>{value}</span>,
        },
        {
            key: "endDate",
            title: "End Date",
            dataIndex: "endDate",
            render: (value: string, record: MenuOption) => <span style={{opacity: record.active ? 1 : 0.5}}>{value}</span>,
        },
        {
            title: "Actions",
            key: "actions",
            render: (_: any, record: MenuOption) => (
                <Space>
                    <Button
                        type="link"
                        onClick={() => {
                            setopenEditMogmol(true);
                            setSelectedOptionDisplayName(record.displayName);
                            setSelectedMenuOptionGuid(record.menuGuid);
                            setSelectedOptionDefaultSelection(record.defaultSelection);
                            setSelectedOptionGuid(record.key);
                            setSelectedOptionStartDate(record.startDate ? dayjs(record.startDate) : null);
                            setSelectedOptionEndDate(record.endDate ? dayjs(record.endDate) : null);
                        }}
                    >
                        Edit
                    </Button>
                    {!isReadOnly && (
                        <Button type="link" onClick={() => handleDeleteOption(record.key)}>
                            Delete
                        </Button>
                    )}
                </Space>
            ),
        },
    ];